import { getUrl } from '../fetch';

export async function submitApplication(): Promise<void> {
    const url = '/api/submit/application';

    await getUrl(url);

    return; // Nothing to return
}
